var _circle, _rect, _rect2, _path, _path2, _path3, _rect3, _path4, _path5, _rect4, _rect5, _rect6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAutomaticReportGeneration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 350,
    viewBox: "0 0 350 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 175,
    cy: 139,
    r: 65,
    fill: "#102F5D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 111,
    width: 224,
    height: 135,
    rx: 4,
    fill: "white",
    stroke: "#102F5D",
    strokeWidth: 15
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 128,
    width: 187,
    height: 100,
    fill: "#102F5D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.4767 268L32 311H318L286.523 268H63.4767Z",
    fill: "white",
    stroke: "#102F5D",
    strokeWidth: 15,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4767 246L32 289H318L286.523 246H63.4767Z",
    fill: "#102F5D",
    stroke: "#102F5D",
    strokeWidth: 15,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M137.566 268L127 283H223L212.434 268H137.566Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 289,
    width: 286,
    height: 22,
    fill: "white",
    stroke: "#102F5D",
    strokeWidth: 15,
    strokeLinejoin: "bevel"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M272 139C274.209 139 276.008 137.208 275.921 135.001C275.005 111.88 266.172 89.7279 250.837 72.2936C235.502 54.8592 214.657 43.2722 191.843 39.4142C189.665 39.0459 187.658 40.6017 187.376 42.7927L175.58 134.49C175.272 136.882 177.136 139 179.548 139H272Z",
    fill: "#102F5D",
    stroke: "white",
    strokeWidth: 14
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M211 134H212.246L170.023 177.006C165.364 181.695 165.373 189.273 170.05 193.95L175 189L170.05 193.95C174.737 198.636 182.335 198.636 187.021 193.95L187.066 193.904L229 151.193V152.5C229 159.127 234.372 164.5 241 164.5C247.627 164.5 253 159.127 253 152.5V122C253 115.373 247.627 110 241 110H211C204.372 110 199 115.373 199 122C199 128.627 204.372 134 211 134Z",
    fill: "white",
    stroke: "#102F5D",
    strokeWidth: 14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 188,
    width: 45,
    height: 65,
    rx: 4,
    fill: "white",
    stroke: "#102F5D",
    strokeWidth: 13
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 211,
    y: 166,
    width: 45,
    height: 87,
    rx: 4,
    fill: "white",
    stroke: "#102F5D",
    strokeWidth: 13
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 139,
    width: 45,
    height: 114,
    rx: 4,
    fill: "white",
    stroke: "#102F5D",
    strokeWidth: 13
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomaticReportGeneration);
export default __webpack_public_path__ + "static/media/automatic-report-generation.7bf869d36de090beea592666f325e639.svg";
export { ForwardRef as ReactComponent };